module.exports = __webpack_public_path__ + "static/media/email-green.6221a3a7.svg";